import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PlanSettingsFields } from "@/components/PlanSettingsFields";
import { Package, PlanSettings } from "@/models/package";
import { useUpdatePackage } from "../hooks/useUpdatePackage";

const settingsOf = (pkg: Package): PlanSettings => ({
  enabledServices: pkg.enabledServices,
  limits: pkg.limits
});

export function PackageCard({ pkg }: { pkg: Package }) {
  const { mutate: updatePackage, isPending } = useUpdatePackage();
  const [settings, setSettings] = useState<PlanSettings>(() => settingsOf(pkg));

  useEffect(() => setSettings(settingsOf(pkg)), [pkg]);

  const isDirty = JSON.stringify(settings) !== JSON.stringify(settingsOf(pkg));

  return (
    <Card>
      <CardHeader>
        <CardTitle>{pkg.name}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <PlanSettingsFields
          idPrefix={pkg.key}
          value={settings}
          onChange={setSettings}
          disabled={isPending}
        />
        <div className="flex justify-end">
          <Button
            onClick={() => updatePackage({ key: pkg.key, settings })}
            disabled={!isDirty || isPending}
          >
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Save
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
